import { useMutation, useQueryClient } from "@tanstack/react-query";

import { InviteUserRequest } from "@/@types/growthos-api/schema/openapi";
import { Notification } from "@/Components";
import { NEST_BACKEND_URL } from "@/lib/axios";
import { axiosApi } from "@/Utils";

export const addUser = async (body: InviteUserRequest): Promise<void> => {
  await axiosApi.post(`/api/team/users`, body, {
    cache: false,
    baseURL: NEST_BACKEND_URL,
  });
};

export const useAddUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addUser,
    onSuccess: () => {
      Notification("success", "Add user successful.");

      // Remove the query completely and refetch
      queryClient.removeQueries({ queryKey: ["team-users"] });
      queryClient.refetchQueries({ queryKey: ["team-users"] });
    },
    onError: (error) => {
      Notification("error", "Add user fail.");
      console.error("Add user error:", error);
    },
  });
};
